export interface Token extends Record<string, unknown> {
  uuid: string;
  name: string;
  token: string;
  tokenType: string;
  createdAt: string;
  expiresAt: string;
}

export enum AccountLicenseTier {
  UNLICENSED = '',
  TRIAL = '0',
  FREE = '1',
  PRO = '2',
  INTERNAL = '3'
}

export enum SiteName {
  LICENSE_INFORMATION = 'licenseInfo'
}
export enum CountryCode {
  DE = 'DE',
  EN = 'EN'
}
export interface Link {
  id: string;
  meta: SiteName;
  lang: CountryCode;
  url: string;
}

export interface TwoFactorActivation extends Record<string, unknown> {
  secret: string;
  qrCodeImage: string;
  // Used in reconfiguration process
  token?: string;
}

export interface IdpBindingRequest extends Record<string, unknown> {
  issuerURL: string;
  clientID: string;
  clientSecret: string;
  providerType: string;
  organizationSlug: string;
  organizationID: string;
  useGracePeriod: boolean;
}

export interface IdpDetails extends Record<string, unknown> {
  issuerURL: string;
  clientID: string;
  providerType: string;
  organizationSlug: string;
  forceReauth: boolean;
  isInGracePeriod: boolean;
}
